export default {
  application: {
    domain: "minimaxi.b2b.aox.pl",
    expireTimeTicket: 4
  },


  header: {
    top: {
      message: 'minimaxi - Internetowa Platforma Handlowa',
      links: [{
          text: "Informacje dla kupujących",
          router: { name: 'showPage', params: {type: 'INFORMATION_BUYERS'}}
        },
        {
          text: "Platforma B2B",
          router: { name: 'showPage', params: {type: 'B2B'}}
        },
        {
          text: "Regulamin",
          router: { name: 'showPage', params: {type: 'REGULATION'}}
        }
      ]
    },
    main: {
      logo: 'https://plimg.redbay.pl/photos/org/03/org/00667915.png',
      searchOptions: [
        {name: "Po nazwie produktu", type: "name"},
        {name: "Po nazwie i opisie produktu", type: "nameAndDesc"},
        {name: "Po kodzie producenta", type: "producerCode"},
        {name: "Po kodzie EAN", type: "ean"},
      ]
    }
  },
  searchPage: {
    optionsLimit: [20, 40, 100],
    optionsSort: [{
        value: "priceAsc",
        text: "od ceny najniższej"
      },
      {
        value: "priceDesc",
        text: "od ceny najdroższej"
      },
      {
        value: "nameAsc",
        text: "alfabetycznie A-Z"
      },
      {
        value: "nameDesc",
        text: "alfabetycznie Z-A"
      },
      {
        value: "quantityAsc",
        text: "od ilości najmniejszej"
      },
      {
        value: "quantityDesc",
        text: "od ilości największej"
      },
    ],
    visibleAttributes: ['SYMBOL_PRODUCENTA'],
    filters: {
      attributes: []
    }
  },
  productPage: {
    visibleAttributes: []
  },
  welcomePage: {
    enabled: true,
  },


  basket: {
    units: {
      single:["szt", "szt.", "sztuka", "mb", "m", "g", "kpl", "usł", "op.", "kart.", "ryza"],
      decimals:["rol", "rol.", "km", "cm"]
    }
  },

  search: {
    searchType: 'standard',
    searchOptions: [
      {name: "Po nazwie produktu", type: "name"},
      {name: "Po kodzie producenta", type: "producerCode"},
      {name: "Po kodzie EAN", type: "ean"},
    ]
  },
  offer: {
    enable: true
  }

};



// WEBPACK FOOTER //
// ./src/settings.js